import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AdviserLabelPipe } from './adviser-label.pipe';
import { StringEqualityPipe } from './string/string-equality.pipe';
import { ConcatPipe } from './array/concat.pipe';
// TODO: revise/remove, use NgCore lib [future release]
import { JoinPipe } from './array/join.pipe';
import { SortByPipe } from './array/sort-by.pipe';
import { SplitPipe } from './array/split.pipe';
import { CheckboxGroupOptionsPipe } from './checkbox-group-options/checkbox-group-options.pipe';
import { ChoiceOptionPipe } from './choice-option/choice-option.pipe';
import { CurrencyWithoutCentsPipe } from './currency/currency-without-cents';
import { CustomTextPipe } from './customisation.pipe';
import { SharedEnableForCountriesPipe } from './enable-for-country.pipe';
import { StringArrayPipe } from './enum/string-array.pipe';
import { FileSizePipe } from './file-size/file-size.pipe';
import { FilterPipe } from './filter-pipe';
import { FormGroupPipe } from './form-group';
import { ApplicantIconPipe } from './icon/applicant-icon.pipe';
import { FileIconPipe } from './icon/file-icon.pipe';
import { LiabilityIconPipe } from './icon/liability-icon.pipe';
import { OpportunityIconPipe } from './icon/opportunity-icon.pipe';
import { ProductSelectionTypeIconPipe } from './icon/product-selection-type-icon.pipe';
import { LoanNamePipe } from './loan-name.pipe';
import { FormatLoanTermPipe } from './loan-term-pipe';
import { ReadableDatePipe } from './readable-date/readable-date.pipe';
import { ReadableDueDatePipe } from './readable-due-date/readable-due-date.pipe';
import { StandardRequirementPipe } from './schema/standard-requirement.pipe';
import { PaddingPipe } from './string/padding.pipe';
import { ToDatePipe } from './string/to-date.pipe';
import { SummaryPipe } from './summary/summary.pipe';
import { YesNoNotGivenPipe } from './yes-no-notgiven.pipe';
import { AdviserRolePipe } from './adviser-role.pipe';
import { SharedRequirementPipe } from './schema/shared-requirement.pipe';
import { ArrayEmptyPipe } from './array/empty.pipe';
import { SentencecasePipe } from './sentencecase.pipe';
import { JsonFormatPipe } from './json-format.pipe';
import { IdExistsInMapPipe } from './id-exists-in-map.pipe';
import { HasVisibleBreakdownItemsPipe } from './has-visible-breakdown-items.pipe';
import { IsVisibleAmountPipe } from './is-visible-amount.pipe';
import { CalculationAnalysisPipe } from './calculation-analysis.pipe';
import { IsLmiApplicablePipe } from './is-lmi-applicable.pipe';
import { IsReverseMortgagePipe } from './product-feature/is-reverse-mortgage.pipe';
import { FilterProductTermsPipe } from './product-feature/filter-product-terms.pipe';

@NgModule({
  declarations: [
    FilterPipe,
    JoinPipe,
    CurrencyWithoutCentsPipe,
    FileSizePipe,
    FileIconPipe,
    OpportunityIconPipe,
    ApplicantIconPipe,
    LiabilityIconPipe,
    ProductSelectionTypeIconPipe,
    ReadableDatePipe,
    SummaryPipe,
    FormatLoanTermPipe,
    ReadableDueDatePipe,
    SortByPipe,
    StandardRequirementPipe,
    YesNoNotGivenPipe,
    StringArrayPipe,
    ConcatPipe,
    LoanNamePipe,
    PaddingPipe,
    SplitPipe,
    ToDatePipe,
    ChoiceOptionPipe,
    CheckboxGroupOptionsPipe,
    FormGroupPipe,
    SharedEnableForCountriesPipe,
    AdviserLabelPipe,
    StringEqualityPipe,
    AdviserRolePipe,
    SharedRequirementPipe,
    CustomTextPipe,
    ArrayEmptyPipe,
    SentencecasePipe,
    JsonFormatPipe,
    IdExistsInMapPipe,
    HasVisibleBreakdownItemsPipe,
    IsVisibleAmountPipe,
    CalculationAnalysisPipe,
    IsLmiApplicablePipe,
    IsReverseMortgagePipe,
    FilterProductTermsPipe
  ],
  imports: [CommonModule],
  exports: [
    FilterPipe,
    JoinPipe,
    CurrencyWithoutCentsPipe,
    FileSizePipe,
    FileIconPipe,
    OpportunityIconPipe,
    ApplicantIconPipe,
    LiabilityIconPipe,
    ProductSelectionTypeIconPipe,
    ReadableDatePipe,
    SummaryPipe,
    FormatLoanTermPipe,
    ReadableDueDatePipe,
    SortByPipe,
    StandardRequirementPipe,
    YesNoNotGivenPipe,
    StringArrayPipe,
    ConcatPipe,
    LoanNamePipe,
    PaddingPipe,
    SplitPipe,
    ToDatePipe,
    ChoiceOptionPipe,
    CheckboxGroupOptionsPipe,
    FormGroupPipe,
    SharedEnableForCountriesPipe,
    AdviserLabelPipe,
    StringEqualityPipe,
    AdviserRolePipe,
    SharedRequirementPipe,
    CustomTextPipe,
    ArrayEmptyPipe,
    SentencecasePipe,
    JsonFormatPipe,
    IdExistsInMapPipe,
    HasVisibleBreakdownItemsPipe,
    IsVisibleAmountPipe,
    CalculationAnalysisPipe,
    IsLmiApplicablePipe,
    IsReverseMortgagePipe,
    FilterProductTermsPipe
  ]
})
export class PipesModule {}
